import { Colors } from "@jsq/ds/styles";
import { EffectiveStatus } from "~/hooks/useDataStudioQueries/constants";
import * as styles from "../styles_vanilla.css";

const isValidEffectiveStatus = (value: string): value is EffectiveStatus => {
  return Object.values(EffectiveStatus).some((enumValue) => enumValue === value);
};

export const getEffectiveStatus = (_jobType: string, status: string): EffectiveStatus => {
  if (isValidEffectiveStatus(status)) {
    return status;
  }

  return EffectiveStatus.IN_PROGRESS;
};

/**
 * Get CSS class name for status tag based on effective status
 */
export const getStatusTagClassName = (status: EffectiveStatus): string => {
  switch (status) {
    case EffectiveStatus.IN_PROGRESS:
      return styles.statusTagInProgress;
    case EffectiveStatus.COMPLETED:
      return styles.statusTagCompleted;
    case EffectiveStatus.FAILED:
      return styles.statusTagFailed;
    default:
      return styles.statusTagDefault;
  }
};

/**
 * Get CSS class name for progress bar fill based on effective status
 */
export const getProgressFillClassName = (status: EffectiveStatus): string => {
  switch (status) {
    case EffectiveStatus.COMPLETED:
      return styles.jobProgressFillCompleted;
    case EffectiveStatus.FAILED:
      return styles.jobProgressFillFailed;
    default:
      return styles.jobProgressFillDefault;
  }
};

/**
 * Get display label for effective status
 */
export const getStatusLabel = (status: EffectiveStatus): string => {
  switch (status) {
    case EffectiveStatus.IN_PROGRESS:
      return "In Progress";
    case EffectiveStatus.COMPLETED:
      return "Complete";
    case EffectiveStatus.FAILED:
      return "Failed";
    default:
      return "Processing";
  }
};

/**
 * Get background color for status tag
 */
export const getStatusBackgroundColor = (status: EffectiveStatus): string => {
  switch (status) {
    case EffectiveStatus.IN_PROGRESS:
      return "#E3F2FD"; // Light blue (Informative background)
    case EffectiveStatus.COMPLETED:
      return "#E8F5E8"; // Light green (Success background)
    case EffectiveStatus.FAILED:
      return "#FFEBEE"; // Light red (Danger background)
    default:
      return "#F5F5F5"; // Light gray (Neutral background)
  }
};

/**
 * Get text color for status tag
 */
export const getStatusTextColor = (status: EffectiveStatus): string => {
  switch (status) {
    case EffectiveStatus.IN_PROGRESS:
      return Colors.Informative600;
    case EffectiveStatus.COMPLETED:
      return Colors.Success600;
    case EffectiveStatus.FAILED:
      return Colors.Danger600;
    default:
      return Colors.Neutral600;
  }
};
